import { z } from 'zod';

import { Textarea, type TextareaProps } from '@/components/controls';

export type FormTextareaProps = TextareaProps;

export const FormTextarea = ({ ...props }: FormTextareaProps) => {
  return <Textarea {...props} />;
};

FormTextarea.displayName = 'Form.Textarea';

export const required = (message = 'The field is required', min = 1) => {
  return z.string({ message }).min(min, { message });
};

FormTextarea.rules = { required };
